<template>
  <div id="app">
    <!-- 顶部导航栏 -->
    <nav v-if="this.$store.state.NavigatorActive != 'gongye'" :class="[
      changeNav == 1 ? 'nav-mod' : 'nav-mod-t',
      this.$route.path.includes('enterprise') ? 'nav-mod-enterprise' : '',
    ]">
      <div class="logo">
        <!-- <div class="logo-img" v-if="changeNav == 1">
          <img src="./assets/home-img/logo.png" alt="中国移动5G+" />
        </div>
        <div class="logo-img distance" v-else>
          <img src="./assets/logo.png" alt="中国移动5G+" />
        </div> -->
        <!-- <div class="block"></div> -->
        <p class="logo-font">开封市工业互联网平台</p>
      </div>
      <div class="items">
        <router-link class="item" :class="[
          this.$store.state.NavigatorActive == 'home'
            ? 'router-link-exact-active'
            : '',
        ]" to="/">首页</router-link>

        <!-- <router-link class="item" :class="[
          this.$store.state.NavigatorActive == 'supply-items' ||
            this.$store.state.NavigatorActive == 'supply-detail'
            ? 'router-link-exact-active'
            : '',
        ]" to="/supply">供需对接</router-link> -->
        <el-dropdown>
          <router-link class="item" :class="[
            this.$store.state.NavigatorActive == 'enterprise-list' ||
              this.$store.state.NavigatorActive == 'enterprise-map'
              ? 'router-link-exact-active'
              : '',
          ]" to="/enterprise-list">企业信息</router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link
                to="/enterprise-list">企业列表&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link
                to="enterprise-map">企业分布图&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown>
          <router-link class="item" :class="[
            this.$store.state.NavigatorActive == 'supply-items' ||
              this.$store.state.NavigatorActive == 'supply-detail'
              ? 'router-link-exact-active'
              : '',
          ]" to="/supply">供需对接</router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link
                to="/yiqiyibiao-shops">仪器仪表&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <router-link class="item" :class="[
          this.$store.state.NavigatorActive == 'industry-shops' ||
            this.$store.state.NavigatorActive == 'industry-detail'
            ? 'router-link-exact-active'
            : '',
        ]" to="/industry">产业电商</router-link>
        <router-link class="item" :class="[
          this.$store.state.NavigatorActive == 'yingyong-shops' ||
            this.$store.state.NavigatorActive == 'yingyong-detail'
            ? 'router-link-exact-active'
            : '',
        ]" to="/yingyong">应用市场</router-link>

        <!-- <a class="item" href="http://111.6.219.213:8082/wlw/">智慧物联</a> -->
        <router-link class="item" :class="[
          this.$store.state.NavigatorActive == 'service-items' ||
            this.$store.state.NavigatorActive == 'service-detail'
            ? 'router-link-exact-active'
            : '',
        ]" to="/service">政企服务</router-link>
        <!-- <el-dropdown>
          <router-link class="item" :class="[
            this.$store.state.NavigatorActive == 'service-items' ||
              this.$store.state.NavigatorActive == 'service-detail'
              ? 'router-link-exact-active'
              : '',
          ]" to="/service">政企服务</router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link to="/service-qiye">企业奖补政策申请</router-link>
            </el-dropdown-item>
            <el-dropdown-item>申报奖补成功企业范例</el-dropdown-item>
            <el-dropdown-item>银企合作平台</el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/service-zhuqi">助企服务</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link  target="_blank" tag="a" to="/gongye">工业淘宝</router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <!-- <a class="item" href="https://www.gy.ha.chinamobile.com/">解决方案</a> -->
        <!-- <a class="item" href="https://www.10086.cn/index/ha/index_371_378.html">移动专区</a> -->
        <router-link class="item" :class="[
          this.$store.state.NavigatorActive == 'wanren-link'
            ? 'router-link-exact-active-t'
            : '',
        ]" to="/wanren-link">
          万人助万企
        </router-link>

        <a class="item" href="https://test.jumh.cn:8083/saas/#/" target="_blank">
          工业应用
        </a>
        <!-- <a class="item" href="http://gongye.kaifeng.gov.cn:8081/charts/">产业大脑</a> -->
        <!-- <div class="country">
          <div class="country-img">
            <img src="./assets/english.png" alt="" />
          </div>
          English
        </div> -->
      </div>
      <el-dropdown class="login" v-if="nickname">
        <div class="el-dropdown-link">
          <img class="avatar" :src="avatar" alt="" srcset="" />
          <span class="name" :style="{ color: changeNav == 1 ? '#000' : '#fff' }">
            {{ nickname }}
          </span>
        </div>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link to="/center"> 个人资料 </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link to="/ruzhu"> 企业入驻 </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link to="/dingdan"> 订单管理 </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <a @click="getout()">退出登录</a>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="login" v-else>
        <router-link class="login-btn-l" to="/login"> 登录 </router-link>
        <router-link class="login-btn-r" to="/sign"> 注册 </router-link>
      </div>
    </nav>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      changeNav: 0,
      nickname: sessionStorage.getItem("nickname"),
      avatar: sessionStorage.getItem("avatar"),
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.body.scrollTop ||
        document.documentElement.scrollTop;
      if (scrollTop > 100) {
        this.changeNav = 1;
      } else {
        this.changeNav = 0;
      }
    },
    getout() {
      sessionStorage.clear();
      location.href = "/";
    },
  },
};
</script>

<style lang="less">
#app {
  color: #2c3e50;
}

.nav-mod-t {
  width: 100%;
  min-width: 1200px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-content: center;
  height: 60px;
  padding: 0 40px;
  background-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0px 3px 6px 1px rgba(28, 38, 96, 0.1);

  .items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;

    .item {
      text-decoration: none;
      margin-right: 60px;
      padding: 10px 1px;
      color: #fff;
      white-space: nowrap;
      cursor: pointer;
      font-size: 20px;
    }

    .country {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;

      .country-img {
        width: 21px;
        height: 21px;
        margin-right: 5px;

        img {
          width: 20px;
        }
      }
    }
  }

  .logo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 23px;
    width: 290px;
    margin-top: 19px;

    .logo-img {
      img {
        height: 30px;
      }
    }

    .block {
      height: 100%;
      width: 1px;
      background-color: #fff;
      margin: 0 7px;
    }

    .logo-font {
      font-weight: 400;
      color: #ffffff;
      white-space: nowrap;
    }
  }

  .login {
    box-shadow: none;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .login-btn-l:hover,
    .login-btn-r:hover {
      box-shadow: 0 4px 10px 1px rgba(255, 255, 255, 0.2);
    }

    .login-btn-l {
      box-shadow: none;
      width: 60px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 4px;
      opacity: 1;
      color: #fff;
      cursor: pointer;
    }

    .login-btn-r {
      box-shadow: none;
      width: 60px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border: 1px solid #69baff;
      border-radius: 4px;
      margin-left: 20px;
      opacity: 1;
      background: linear-gradient(270deg, #69baff 0%, #30a5ff 100%);
      color: #fff;
      cursor: pointer;
    }
  }

  .router-link-exact-active {
    box-shadow: 0px 2px 0px 0px #fff;
  }
}

.nav-mod-enterprise {
  background-color: #054eb7;
}

.nav-mod {
  width: 100%;
  min-width: 1200px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-content: center;
  height: 60px;
  padding: 0 40px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px 1px rgba(28, 38, 96, 0.1);

  .items {
    width: 434px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    padding: 0 0 0 152px;

    .item {
      text-decoration: none;
      margin-right: 60px;
      padding: 10px 1px;
      white-space: nowrap;
      cursor: pointer;
      font-size: 20px;
    }

    .country {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #000;

      .country-img {
        width: 21px;
        height: 21px;
        margin-right: 5px;

        img {
          width: 20px;
        }
      }
    }
  }

  .logo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 23px;
    margin-top: 19px;
    width: 290px;

    .logo-img {
      height: 25px;

      img {
        height: 24px;
      }
    }

    .distance {
      padding-right: 8px;
      margin-right: 8px;
    }

    .logo-font {
      font-weight: 400;
      color: #000;
      line-height: 0px;
      white-space: nowrap;
    }
  }

  .login {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .login-btn-l:hover,
    .login-btn-r:hover {
      box-shadow: 0 4px 10px 1px rgba(4, 51, 93, 0.2);
    }

    .login-btn-l {
      width: 60px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border: 1px solid #707070;
      border-radius: 4px;
      opacity: 1;
      color: #000;
      cursor: pointer;
    }

    .login-btn-r {
      width: 60px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border: 1px solid #69baff;
      border-radius: 4px;
      margin-left: 20px;
      opacity: 1;
      background: linear-gradient(270deg, #69baff 0%, #30a5ff 100%);
      color: #fff;
      cursor: pointer;
    }
  }

  .router-link-exact-active {
    color: #1890ff;
    box-shadow: 0px 2px 0px 0px #1890ff;
  }
}

.avatar {
  width: 40px;
  border-radius: 50%;
}

.name {
  margin-left: 10px;
  color: #fff;
}
</style>
